module.exports = __webpack_public_path__ + "static/img/AT.a796c7b2.png";